// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-footer[data-v-5116aca7] {\r\n  z-index: 10;\n}\r\n", ""]);
// Exports
module.exports = exports;
